module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/episode01-1005ebba14035eb6629923bb3b1d72dd.jpg";